import React, { useEffect, useState } from 'react';
import CreateQuestions from '../../../component/EliteGame/CreateQuestions';
import QuestionsList from '../../../component/EliteGame/QuestionsList';
import {
  createQuestion,
  deleteQuestion,
  GetMainCategories,
  getQuestionsByQuizType,
  GetSubCategories,
  updateQuestion
} from '../../../api/eliteGameApi';
import { ELITE_QUIZ_TYPE } from '../../../utils/constants';
import { errorToast, successToast } from '../../../utils/helper';
import { useEliteGames } from '../../../context/EliteGamesContext';
import ViewQuestionModal from '../../../component/EliteGame/ViewQuestionModal';
import DeletePopup from '../../../component/common/modals/DeletePopup';
import { useRef } from 'react';
const MultiMatchManageQuestions = () => {
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { setLoading } = useEliteGames();
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewQuestion, setViewQuestion] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [questionId, setQuestionId] = useState(null);
  const [open, setOpen] = useState(false);

  const formRef = useRef(null);
  // Fetch main categories on component mount
  const handleView = (question) => {
    setViewQuestion(question);
    setViewModalOpen(true);
  };

  const getMainCategories = async () => {
    setLoading(true);
    try {
      const data = await GetMainCategories(
        { quizType: ELITE_QUIZ_TYPE.MULTI_MATCH, limit: 50 },
        true
      );
      setMainCategories(data.data || []);
    } catch (error) {
      console.error('Failed to fetch main categories', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch questions based on filters and pagination
  const getQuestions = async (filter = {}) => {
    setLoading(true);
    try {
      const data = await getQuestionsByQuizType(ELITE_QUIZ_TYPE.MULTI_MATCH, {
        page: page,
        limit: limit,
        ...filter
      });
      setQuestions(data || []);
    } catch (error) {
      console.error('Failed to fetch questions', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch subcategories based on selected main category
  useEffect(() => {
    getMainCategories();
  }, []);

  //  Fetch subcategories when main category changes
  useEffect(() => {
    getQuestions();
  }, [refresh, page, limit]);

  // Fetch subcategories when main category changes
  const getSubCategories = async (mainCategoryId) => {
    setLoading(true);
    try {
      const data = await GetSubCategories(
        { categoryId: mainCategoryId, quizType: ELITE_QUIZ_TYPE.MULTI_MATCH, limit: 50 },
        true
      );
      setSubCategories(data.data || []);
    } catch (error) {
      console.error('Failed to fetch sub categories', error);
    } finally {
      setLoading(false);
    }
  };

  // Handle question edit
  const handleEdit = (question) => {
    setSelectedQuestion(question);
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  // Handle question submission
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      console.log(data);
      let correctAnswer = data.answer.map((ans) => data[ans.value || ans]);
      console.log('Correct Answer:', correctAnswer);
      const formData = {
        ...data,
        quizType: ELITE_QUIZ_TYPE.MULTI_MATCH,
        options: [
          data.optionA,
          data.optionB,
          ...(data.questionType !== 2 ? [data.optionC, data.optionD] : [])
        ],
        correctAnswer: correctAnswer
      };
      console.log('Form Data Submitted:', formData);
      if (selectedQuestion) {
        const response = await updateQuestion(formData, selectedQuestion._id);
        successToast('Question updated successfully', response.message);
        setSelectedQuestion(null);
      } else {
        const response = await createQuestion(formData);

        successToast('Question created successfully', response.message);
      }
      getQuestions(); // Refresh questions list after creating a new question
      setSelectedQuestion({}); //
      setSelectedQuestion(null); // Clear selected question after submission
    } catch (error) {
      console.error('Failed to create question:', error);
      errorToast('Failed to create question. Please try again.', error.message);
    } finally {
      setLoading(false);
    }
    setRefreshFlag((prev) => prev + 1);
    setRefresh(!refresh);
  };

  // Handle filter action for questions
  const handleFilter = (filter) => {
    getQuestions(filter);
  };

  // Handle refresh action for questions (reset pagination and reload)
  const handleRefresh = () => {
    setPage(1);
    getQuestions();
  };

  // Handle deletion of a question
  const handleDelete = async () => {
    setLoading(true);
    try {
      // Call API to delete question
      await deleteQuestion(questionId);
      successToast('Question deleted successfully');
      setRefresh(true); // Refresh questions list after deletion
    } catch (error) {
      errorToast('Error deleting question:', error);
    } finally {
      setLoading(false);
    }
    setRefresh(!refresh);
  };
  return (
    <div>
      <div ref={formRef}>
        <CreateQuestions
          onSubmit={onSubmit}
          name={'Multi Match'}
          quizType={ELITE_QUIZ_TYPE.MULTI_MATCH}
          mainCategories={mainCategories}
          getSubCategories={getSubCategories}
          subCategories={subCategories}
          existingQuestion={selectedQuestion}
          resetTrigger={refreshFlag}
        />
      </div>
      <div className="bg-white rounded-lg shadow p-6 m-4">
        <div className="mb-2">
          <span className="text-2xl font-bold text-black-600">Questions for Multi Match</span>
        </div>
        <hr className="mb-6" />
        <QuestionsList
          quizType={ELITE_QUIZ_TYPE.MULTI_MATCH}
          questions={questions}
          categoryList={mainCategories}
          subCategoryList={subCategories}
          getSubCategories={getSubCategories}
          setRefresh={setRefresh}
          page={page}
          limit={limit}
          setLimit={setLimit}
          setPage={setPage}
          onEdit={handleEdit}
          onFilter={handleFilter}
          onRefresh={handleRefresh}
          onDelete={(id) => {
            setQuestionId(id);
            setOpen(true);
          }}
          onView={handleView}
        />
        {DeletePopup({
          title: 'Confirm Deletion',
          open,
          setOpen,
          message:
            'Are you sure you want to delete this question? All related data will also be deleted.',
          setDelete: handleDelete
        })}
      </div>
      <ViewQuestionModal
        questions={viewQuestion}
        isOpen={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
      />
    </div>
  );
};

export default MultiMatchManageQuestions;
